<script lang="ts">
	import type { HomepageCategory } from "../templates/HomepageProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import ServiceCard from "./ServiceCard.svelte";
	import translation from "./Services.translations.json" with { type: "json" };
	import Button from "./common/Button.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const translate = getTranslate(translation);

	let showAll = $state(false);

	const { categories }: { categories: HomepageCategory[] } = $props();
</script>

<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
	{#each categories as category, cardIndex (category.id)}
		<div
			class:hidden={cardIndex >= 4 && !showAll}
			class:lg:block={cardIndex >= 4 && !showAll && cardIndex < 6}
			class:xl:block={cardIndex >= 4 && !showAll}
		>
			<ServiceCard {category} />
		</div>
	{/each}

	{#if categories.length > 4 && !showAll}
		<Button
			variant={ButtonVariant.OutlinedWithIconTight}
			onclick={(): void => {
				showAll = true;
			}}
			class="sm:col-span-2  block  xl:hidden"
		>
			{translate("showAll")}
		</Button>
	{/if}
</div>
